import React, { Component } from 'react'
import {
    Route,
    Redirect,
} from 'react-router-dom'
import {
    authedUserConnect,
    withRouter,
} from '../../validator'
import { setSuccessAction } from '../../components/nav/login-buttons'
import { isWebView } from '../../admin/actions'
import { isAccessToken } from '../../components/auth/token-query-params'

@withRouter()
@authedUserConnect()
export class LoggedRoute extends Component {
    /**
     * Check if can be route redirected into login for non authed user
     *
     * @type {boolean}
     */
    canRedirectToLogin = !isWebView() && !this.props.authedUser && !isAccessToken

    /**
     * Render logged route
     *
     * @return {*}
     */
    render() {
        if (this.canRedirectToLogin) {
            setSuccessAction()
            return <Redirect to='/login' />
        }

        return <Route {...this.props} />
    }
}
